import {ColumnMain} from "../column-main";
import {Column} from "../column";
import {Trans} from "@lingui/macro";
import React from "react";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import {Tag} from "antd";

const CertificateListModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({key:'deliveryNoteNumber', filter:true, fixed: 'left', width: 200, sorter:true, direction:"desc", title:<Trans>Delivery Note Number</Trans>,
        render: (text, row, index) => {

            let color = 'default';

            switch(row['status']) {
                case 'CAN_BE_USED':
                case 'TAKEN_BACK_FROM_PRODUCTION':
                    color = 'white';
                    break;
                case 'PRODUCED':
                    color = '#b7eb8f';
                    break;
                case 'LOCKED':
                    color = 'gold';
                    break;
                case 'SCRAP':
                    color = '#ffa39e';
                    break;
            }
            return { props: { style: {background: color} }, children: <>{text}</> };
        }
    });
    columns.push({key:'rollNumber', filter:true, fixed: 'left', width: 150, sorter:true,title:<Trans>Roll Number</Trans>,
        render: (text, row, index) => {

            let color = 'default';

            switch(row['status']) {
                case 'CAN_BE_USED':
                case 'TAKEN_BACK_FROM_PRODUCTION':
                    color = 'white';
                    break;
                case 'PRODUCED':
                    color = '#b7eb8f';
                    break;
                case 'LOCKED':
                    color = 'gold';
                    break;
                case 'SCRAP':
                    color = '#ffa39e';
                    break;
            }
            return { props: { style: {background: color} }, children: <>{text}</> };
        }
    });
    columns.push({key:'item.fifoNumber',  fixed: 'left', width: 200, dataIndex: ['item', 'fifoNumber'], filter:true, sorter:true,title:<Trans>Fifo number</Trans>,
        render: (text, row, index) => {

            let color = 'default';

            switch(row['status']) {
                case 'CAN_BE_USED':
                case 'TAKEN_BACK_FROM_PRODUCTION':
                    color = 'white';
                    break;
                case 'PRODUCED':
                    color = '#b7eb8f';
                    break;
                case 'LOCKED':
                    color = 'gold';
                    break;
                case 'SCRAP':
                    color = '#ffa39e';
                    break;
            }
            return { props: { style: {background: color} }, children: <>{text}</> };
        }
    });
    columns.push({key:'item.itemNo', width: 200, dataIndex: ['item', 'itemNo'], filter:true, sorter:true,title:<Trans>ItemNo</Trans>});
    columns.push({
        key:'status',
        width: 200,
        sorter:true,
        title:<Trans>Status</Trans>,
        uniqueSelectFilterData: [
            { label: <Trans>All</Trans>, value: null },
            { label: <Trans>Manufactured</Trans>, value: 'PRODUCED' },
            { label: <Trans>Usable</Trans>, value: 'CAN_BE_USED' },
            { label: <Trans>Locked</Trans>, value: 'LOCKED' },
            { label: <Trans>Scrap</Trans>, value: 'SCRAP' },
            { label: <Trans>Returned from production</Trans>, value: 'TAKEN_BACK_FROM_PRODUCTION' },
        ],
        render: (status: string) => {
            let color = 'default';
            let label: React.ReactNode = status;

            switch(status) {
                case 'PRODUCED':
                    color = 'green';
                    label = <Trans>Manufactured</Trans>;
                    break;
                case 'CAN_BE_USED':
                    color = 'blue';
                    label = <Trans>Usable</Trans>;
                    break;
                case 'LOCKED':
                    color = 'gold';
                    label = <Trans>Locked</Trans>;
                    break;
                case 'SCRAP':
                    color = 'red';
                    label = <Trans>Scrap</Trans>;
                    break;
                case 'TAKEN_BACK_FROM_PRODUCTION':
                    color = 'blue';
                    label = <Trans>Returned from production</Trans>;
                    break;
            }

            return <Tag color={color}>{label}</Tag>;
        }
    });
    columns.push({key:'item.sizeX', width: 200, dataIndex: ['item', 'sizeX'], filter:true, sorter:true,title:<Trans>Size X</Trans>});
    columns.push({key:'item.sizeY', width: 200, dataIndex: ['item', 'sizeY'], filter:true, sorter:true,title:<Trans>Size Y</Trans>});
    columns.push({key:'item.normWeight', width: 200, dataIndex: ['item', 'normWeight'], filter:true, sorter:true,title:<Trans>Norm weight (kg)</Trans>});
    columns.push({key:'weight', filter:true, sorter:true, width: 200, title:<Trans>Weight</Trans>});
    columns.push({key:'item.quality', width: 200, dataIndex: ['item', 'quality'], filter:true, sorter:true,title:<Trans>Quality</Trans>});
    columns.push({key:'supplier.name', width: 200, dataIndex: ['supplier', 'name'], filter:true, sorter:true,title:<Trans>Supplier</Trans>});
    columns.push({key:'manufacturerName', width: 200, filter:true, sorter:true,title:<Trans>Manufacturer Name</Trans>});
    columns.push({key:'manufacturerId', width: 200, filter:true, sorter:true,title:<Trans>Manufacturer ID</Trans>});
    columns.push({
        key:'certificateLink', 
        width: 250, 
        filter:true, 
        sorter:true,
        title:<Trans>Certificate Link</Trans>,
        render: (text: string) => text ? <>{text}</> : '-'
    });
    columns.push({
        key:'certificateQuality',
        width: 180,
        sorter:true,
        title:<Trans>Minősítés</Trans>,
        uniqueSelectFilterData: [
            { label: <Trans>All</Trans>, value: null },
            { label: 'Megfelelő', value: 'MEGFELELO' },
            { label: 'Nem megfelelő', value: 'NEM_MEGFELELO' },
            { label: 'Hiányos', value: 'HIANYOS' },
        ],
        render: (value: string) => {
            if (!value) return '-';
            switch (value) {
                case 'MEGFELELO': return <Tag color="green">Megfelelő</Tag>;
                case 'NEM_MEGFELELO': return <Tag color="red">Nem megfelelő</Tag>;
                case 'HIANYOS': return <Tag color="orange">Hiányos</Tag>;
                default: return value;
            }
        }
    });
    columns.push({
        key:'hasCertificate',
        width: 200,
        filter:true,
        checkboxFilter: true,
        fixed: 'right',
        sorter:true,
        title:<div style={{textAlign: "center"}}><Trans>Has Certificate</Trans></div>,
        render: (value: boolean) =>
            value
                ? <div style={{textAlign: "center"}}><CheckCircleTwoTone twoToneColor="#52c41a"/></div>
                : <div style={{textAlign: "center"}}><CloseCircleTwoTone twoToneColor="#ff4d4f"/></div>
    });

    return{
        columns:columns,
        url:"/resource/stock"
    };

}
export default CertificateListModel();
